export default __webpack_public_path__ + "static/media/vip-12.98a3bd8b.svg";